/**
 * OMG section — cursor star trail (mousemove / touchmove).
 * Depends on [data-cu-omg-root] inside .section_ohmygummies.
 */
(function () {
  var DROP_ANIMATIONS = ['cu-omg-star-drop-a', 'cu-omg-star-drop-b'];
  var animToggle = 0;

  function prefersReducedMotion() {
    return (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function parseConfig(root) {
    var d = root.dataset;
    return {
      minPathPx: parseFloat(d.cuMinDistance || '100') || 100,
      minIntervalMs: parseFloat(d.cuMinIntervalMs || '180') || 180,
      sizeSlow: parseFloat(d.cuStarSizeSlow || '25') || 25,
      sizeMid: parseFloat(d.cuStarSizeMid || '40') || 40,
      sizeFast: parseFloat(d.cuStarSizeFast || '80') || 80,
      durationMs: parseFloat(d.cuDurationMs || '1400') || 1400,
      fallPx: parseFloat(d.cuFallPx || '100') || 100,
    };
  }

  function randomStarSizePx(c) {
    var tiers = [c.sizeSlow, c.sizeMid, c.sizeFast];
    return tiers[Math.floor(Math.random() * 3)];
  }

  function distance(a, b) {
    var dx = a.x - b.x;
    var dy = a.y - b.y;
    return Math.sqrt(dx * dx + dy * dy);
  }

  function pointRelativeToRoot(root, clientX, clientY) {
    var rect = root.getBoundingClientRect();
    return {
      x: clientX - rect.left,
      y: clientY - rect.top,
    };
  }

  function removeAfterAnimation(el, fallbackMs) {
    function done() {
      if (el && el.parentNode) {
        el.parentNode.removeChild(el);
      }
    }
    el.addEventListener('animationend', done, { once: true });
    window.setTimeout(done, fallbackMs + 200);
  }

  function createStar(layer, point, config) {
    var span = document.createElement('span');
    span.className = 'star';
    span.setAttribute('aria-hidden', 'true');
    var size = randomStarSizePx(config);
    var startScale = 1.02 + Math.random() * 0.1;
    span.style.setProperty('--star-start-scale', startScale.toFixed(3));
    span.style.setProperty('--cu-omg-fall', config.fallPx + 'px');
    span.style.left = point.x + 'px';
    span.style.top = point.y + 'px';
    span.style.width = size + 'px';
    span.style.height = size + 'px';
    span.style.animationName =
      DROP_ANIMATIONS[animToggle++ % DROP_ANIMATIONS.length];
    var durMs =
      Math.round(config.durationMs * (0.94 + Math.random() * 0.12)) ||
      config.durationMs;
    span.style.animationDuration = durMs + 'ms';
    span.style.animationTimingFunction =
      'cubic-bezier(0.52, 0.02, 0.28, 1)';
    span.style.animationFillMode = 'forwards';
    layer.appendChild(span);
    removeAfterAnimation(span, durMs);
  }

  function initCuOmg(root) {
    if (!root || root.dataset.cuOmgReady === 'true') {
      return;
    }

    var layer = root.querySelector('.cu-omg-stars-layer');
    if (!layer) {
      return;
    }

    if (prefersReducedMotion()) {
      root.dataset.cuOmgReady = 'true';
      return;
    }

    var config = parseConfig(root);
    if (root.dataset.cuStarTrail !== '1') {
      root.dataset.cuOmgReady = 'true';
      return;
    }

    var state = {
      prevPoint: null,
      pathSinceSpawn: 0,
      lastSpawnTime: 0,
    };

    function shouldSpawn(now) {
      var pathOk = state.pathSinceSpawn >= config.minPathPx;
      var cooledDown = now - state.lastSpawnTime >= config.minIntervalMs;
      return pathOk && cooledDown;
    }

    function onMove(clientX, clientY) {
      var point = pointRelativeToRoot(root, clientX, clientY);
      var now = Date.now();

      if (state.prevPoint) {
        state.pathSinceSpawn += distance(state.prevPoint, point);
      }
      state.prevPoint = point;

      if (shouldSpawn(now)) {
        createStar(layer, point, config);
        state.pathSinceSpawn = 0;
        state.lastSpawnTime = now;
      }
    }

    function onMouseMove(e) {
      onMove(e.clientX, e.clientY);
    }

    function onTouchMove(e) {
      if (e.touches && e.touches[0]) {
        onMove(e.touches[0].clientX, e.touches[0].clientY);
      }
    }

    root.addEventListener('mousemove', onMouseMove);
    root.addEventListener('touchmove', onTouchMove, { passive: true });

    root._cuOmgDestroy = function () {
      root.removeEventListener('mousemove', onMouseMove);
      root.removeEventListener('touchmove', onTouchMove);
      layer.innerHTML = '';
      delete root._cuOmgDestroy;
      delete root.dataset.cuOmgReady;
    };

    root.dataset.cuOmgReady = 'true';
  }

  function destroyCuOmg(root) {
    if (root && typeof root._cuOmgDestroy === 'function') {
      root._cuOmgDestroy();
    }
  }

  function scanAndInit(container) {
    var scope = container || document;
    var nodes = scope.querySelectorAll('[data-cu-omg-root]');
    for (var i = 0; i < nodes.length; i++) {
      initCuOmg(nodes[i]);
    }
  }

  function registerGlobalListenersOnce() {
    if (window.__cuOmgListeners) {
      return;
    }
    window.__cuOmgListeners = true;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        scanAndInit();
      });
    }

    document.addEventListener('shopify:section:load', function (event) {
      scanAndInit(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var roots = event.target.querySelectorAll('[data-cu-omg-root]');
      for (var i = 0; i < roots.length; i++) {
        destroyCuOmg(roots[i]);
      }
    });
  }

  registerGlobalListenersOnce();
  scanAndInit();
})();
